import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _nodeViewRenderers;
var _excluded = ["node"],
  _excluded2 = ["node"],
  _excluded3 = ["node"],
  _excluded4 = ["node"],
  _excluded5 = ["node", "type"],
  _excluded6 = ["node"],
  _excluded7 = ["node"];
import loadable from "@loadable/component";
import React, { useMemo } from "react";
import { Node_Type } from "./../../../ricos-types/index.js";
var CollapsibleListRenderer = function CollapsibleListRenderer(_ref) {
  var node = _ref.node,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  var CollapsibleList = useMemo(function () {
    return loadable({
      resolved: {},
      chunkName: function chunkName() {
        return "ricos_plugin_collapsibleList";
      },
      isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
          return false;
        }
        if (typeof __webpack_modules__ !== 'undefined') {
          return !!__webpack_modules__[key];
        }
        return false;
      },
      importAsync: function importAsync() {
        return import(/* webpackChunkName: "ricos_plugin_collapsibleList" */"../collapsibleList-loadable.js");
      },
      requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function (resolved) {
          _this.resolved[key] = true;
          return resolved;
        });
      },
      requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (typeof __webpack_require__ !== 'undefined') {
          return __webpack_require__(id);
        }
        return eval('module.require')(id);
      },
      resolve: function resolve() {
        if (require.resolveWeak) {
          return require.resolveWeak("../collapsibleList-loadable.js");
        }
        return eval('require.resolve')("../collapsibleList-loadable.js");
      }
    });
  }, []);
  return /* @__PURE__ */React.createElement(CollapsibleList, _extends({
    key: node.id,
    node: node
  }, props));
};
var CollapsibleListLoadable = function CollapsibleListLoadable(_ref2) {
  var node = _ref2.node,
    props = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  return /* @__PURE__ */React.createElement(CollapsibleListRenderer, _extends({
    key: node.id,
    node: node
  }, props));
};
var CollapsibleListItemRenderer = function CollapsibleListItemRenderer(_ref3) {
  var node = _ref3.node,
    props = _objectWithoutPropertiesLoose(_ref3, _excluded3);
  var CollapsibleListItem = useMemo(function () {
    return loadable({
      resolved: {},
      chunkName: function chunkName() {
        return "ricos_plugin_collapsibleListItem";
      },
      isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
          return false;
        }
        if (typeof __webpack_modules__ !== 'undefined') {
          return !!__webpack_modules__[key];
        }
        return false;
      },
      importAsync: function importAsync() {
        return import(/* webpackChunkName: "ricos_plugin_collapsibleListItem" */"../collapsibleListItem-loadable.js");
      },
      requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function (resolved) {
          _this.resolved[key] = true;
          return resolved;
        });
      },
      requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (typeof __webpack_require__ !== 'undefined') {
          return __webpack_require__(id);
        }
        return eval('module.require')(id);
      },
      resolve: function resolve() {
        if (require.resolveWeak) {
          return require.resolveWeak("../collapsibleListItem-loadable.js");
        }
        return eval('require.resolve')("../collapsibleListItem-loadable.js");
      }
    });
  }, []);
  return /* @__PURE__ */React.createElement(CollapsibleListItem, _extends({
    key: node.id,
    node: node
  }, props));
};
var CollapsibleListItemLoadable = function CollapsibleListItemLoadable(_ref4) {
  var node = _ref4.node,
    props = _objectWithoutPropertiesLoose(_ref4, _excluded4);
  return /* @__PURE__ */React.createElement(CollapsibleListItemRenderer, _extends({
    key: node.id,
    node: node
  }, props));
};
var CollapsibleItemPropertyRenderer = function CollapsibleItemPropertyRenderer(_ref5) {
  var node = _ref5.node,
    type = _ref5.type,
    props = _objectWithoutPropertiesLoose(_ref5, _excluded5);
  var CollapsibleItemProperty = useMemo(function () {
    return loadable({
      resolved: {},
      chunkName: function chunkName() {
        return "ricos_plugin_collapsibleListPropertyRenderer";
      },
      isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
          return false;
        }
        if (typeof __webpack_modules__ !== 'undefined') {
          return !!__webpack_modules__[key];
        }
        return false;
      },
      importAsync: function importAsync() {
        return import(/* webpackChunkName: "ricos_plugin_collapsibleListPropertyRenderer" */"../collapsibleItemProperty-loadable.js");
      },
      requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function (resolved) {
          _this.resolved[key] = true;
          return resolved;
        });
      },
      requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (typeof __webpack_require__ !== 'undefined') {
          return __webpack_require__(id);
        }
        return eval('module.require')(id);
      },
      resolve: function resolve() {
        if (require.resolveWeak) {
          return require.resolveWeak("../collapsibleItemProperty-loadable.js");
        }
        return eval('require.resolve')("../collapsibleItemProperty-loadable.js");
      }
    });
  }, []);
  return /* @__PURE__ */React.createElement(CollapsibleItemProperty, _extends({
    key: node.id,
    node: node
  }, props, {
    type: type
  }));
};
var CollapsibleItemTitlePropertyLoadable = function CollapsibleItemTitlePropertyLoadable(_ref6) {
  var node = _ref6.node,
    props = _objectWithoutPropertiesLoose(_ref6, _excluded6);
  return /* @__PURE__ */React.createElement(CollapsibleItemPropertyRenderer, _extends({
    key: node.id,
    node: node
  }, props, {
    type: "title"
  }));
};
var CollapsibleItemBodyPropertyLoadable = function CollapsibleItemBodyPropertyLoadable(_ref7) {
  var node = _ref7.node,
    props = _objectWithoutPropertiesLoose(_ref7, _excluded7);
  return /* @__PURE__ */React.createElement(CollapsibleItemPropertyRenderer, _extends({
    key: node.id,
    node: node
  }, props, {
    type: "body"
  }));
};
var nodeViewRenderers = (_nodeViewRenderers = {}, _nodeViewRenderers[Node_Type.COLLAPSIBLE_LIST] = CollapsibleListLoadable, _nodeViewRenderers[Node_Type.COLLAPSIBLE_ITEM] = CollapsibleListItemLoadable, _nodeViewRenderers[Node_Type.COLLAPSIBLE_ITEM_TITLE] = CollapsibleItemTitlePropertyLoadable, _nodeViewRenderers[Node_Type.COLLAPSIBLE_ITEM_BODY] = CollapsibleItemBodyPropertyLoadable, _nodeViewRenderers);
export { nodeViewRenderers };